const STORAGE_KEY = 'booking_form_data'
const EXPIRATION_TIME = 30 * 24 * 60 * 60 * 1000

export default class LocalStorageService {
  static saveFormData (data) {
    const storageData = {
      data,
      timestamp: new Date().getTime(),
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(storageData))
  }

  static getFormData () {
    const storageData = localStorage.getItem(STORAGE_KEY)
    if (!storageData) return null

    const { data, timestamp } = JSON.parse(storageData)
    const now = new Date().getTime()

    if (now - timestamp > EXPIRATION_TIME) {
      localStorage.removeItem(STORAGE_KEY)
      return null
    }

    return data
  }

  static clearFormData () {
    localStorage.removeItem(STORAGE_KEY)
  }
} 


// WEBPACK FOOTER //
// ./src/services/LocalStorageService.js